/**
 * Zweck: Beschreibt die TypeScript-Bausteine für den Frontend-Bereich frontend/src/app/dialogs/privacy/app.dialogs.privacy.component.ts.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {AppConfigService} from '../../services/app.config.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {PrivacySettings} from '../../models/privacy-settings';

/**
 * Zweck: Beschreibt class AppDialogsPrivacyComponent und ihren Daten- oder Funktionsvertrag.
 */
@Component({
    templateUrl: 'app.dialogs.privacy.component.html',
    styleUrls: ['app.dialogs.privacy.component.scss'],
    standalone: false
})
export class AppDialogsPrivacyComponent implements OnInit {
  details = false;

  keys = [];

/**
 * Beschreibt Methode constructor und ihren Rückgabevertrag.
 */
  constructor(private ref: MatDialogRef<AppDialogsPrivacyComponent>,
              @Inject(MAT_DIALOG_DATA) public data: PrivacySettings, public cfg: AppConfigService) {
  }

/**
 * Beschreibt Methode ngOnInit und ihren Rückgabevertrag.
 */
  ngOnInit(): void {
    this.keys = Object.keys(this.data);
  }

/**
 * Beschreibt Methode showDetails und ihren Rückgabevertrag.
 */
  showDetails() {
    this.details = true;
  }

/**
 * Beschreibt Methode hideDetails und ihren Rückgabevertrag.
 */
  hideDetails() {
    this.details = false;
  }

/**
 * Beschreibt Methode close und ihren Rückgabevertrag.
 */
  close() {
    this.ref.close(this.data);
  }

/**
 * Beschreibt Methode acceptAll und ihren Rückgabevertrag.
 */
  acceptAll() {
    Object.keys(this.data).forEach(k => {
      this.data[k] = true;
    });

    this.close();
  }
}
